import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';
import { NavBar, HeroBanner } from './components';
import { Home, Knockout, Semifinal, WinnerPage } from './pages';
import { useTournament } from './hooks/useTournament';

function App() {
  const {
    groups,
    knockoutMatches,
    semifinalMatches,
    winner,
    groupNames,
    classifiedTeams,
    canGenerateKnockout,
    resetTournament,
    addGroup,
    addTeam,
    addMatch,
    createKnockoutPhase,
    addKnockoutResult,
    addSemifinalResult,
  } = useTournament();

  const [isResetModalOpen, setIsResetModalOpen] = useState(false);

  const handleResetConfirm = () => {
    resetTournament();
    setIsResetModalOpen(false);
  };

  return (
    <Router>
      <NavBar />
      <main className="container">
        <HeroBanner
          groupsCount={groups.length}
          knockoutMatchesCount={knockoutMatches.length}
          winner={winner}
          onResetClick={() => setIsResetModalOpen(true)}
        />

        <Routes>
          <Route path="/" element={
            <Home
              groups={groups}
              groupNames={groupNames}
              classifiedTeams={classifiedTeams}
              canGenerateKnockout={canGenerateKnockout}
              addGroup={addGroup}
              addTeam={addTeam}
              addMatch={addMatch}
              createKnockoutPhase={createKnockoutPhase}
            />
          } />
          <Route path="/knockout" element={
            <Knockout knockoutMatches={knockoutMatches} addKnockoutResult={addKnockoutResult} />
          } />
          <Route path="/semifinal" element={
            <Semifinal semifinalMatches={semifinalMatches} addSemifinalResult={addSemifinalResult} />
          } />
          <Route path="/winner" element={<WinnerPage winner={winner} />} />
        </Routes>

        {isResetModalOpen && (
          <div className="modal-overlay" role="presentation" onClick={() => setIsResetModalOpen(false)}>
            <div
              className="modal-card"
              role="dialog"
              aria-modal="true"
              aria-labelledby="reset-modal-title"
              onClick={(event) => event.stopPropagation()}
            >
              <h2 id="reset-modal-title"><FaExclamationTriangle /> Reiniciar torneo</h2>
              <p>Esta acción eliminará todos los datos guardados del torneo. ¿Deseas continuar?</p>
              <div className="modal-actions">
                <button type="button" className="btn btn--ghost" onClick={() => setIsResetModalOpen(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn--danger" onClick={handleResetConfirm}>
                  Sí, reiniciar
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </Router>
  );
}

export default App;
